/* eslint-disable no-useless-escape */
import { useQuery } from "@redux-requests/react";
import { last } from "lodash";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { types } from "../ducks";

const useVimeoData = videoUrl => {
  const vimeoId = videoUrl ? last(videoUrl.split("/")) : null;
  const dispatch = useDispatch();
  useEffect(() => {
    // Avoid metadata request if video is not Vimeo
    if (!/^(http:\/\/|https:\/\/)(vimeo\.com)\/([\w\/]+)([\?].*)?$/.test(videoUrl)) return;

    if (vimeoId) {
      dispatch({
        type: types.GET_VIMEO_DATA,
        request: {
          baseURL: "https://vimeo.com",
          url: `/api/v2/video/${vimeoId}.json`
        },
        meta: {
          requestKey: vimeoId,
          noCredentails: true,
          noSerialize: true
        }
      });
    }
  }, [dispatch, vimeoId]);

  const { data: videoData } = useQuery({
    type: types.GET_VIMEO_DATA,
    requestKey: vimeoId,
    defaultData: [{}]
  });

  if (Array.isArray(videoData) && videoData.length > 0) {
    return { imageUrl: videoData[0].thumbnail_medium, duration: videoData[0].duration };
  }
  return {};
};

export default useVimeoData;
